module.exports = __webpack_public_path__ + "fonts/00cd656.TTF";